<script>
    import { slide } from 'svelte/transition';
    export let label = "";
    export let required = false;
    export let value = "";
    export let fieldName = "";
    export let options = [];
    export let onChange = null;
    export let style = "";
    export let compact = false;

    let inputID = Math.random().toString(36).slice(2, 12);
    let showSuggestions = false;
    let filteredOptions = [];
    
    let inputElement;
    let suggestionsStyle = "";
    
    function filterOptions(searchText) {
        if (!options || options.length === 0) {
            return;
        }
        if (!searchText) {
            filteredOptions = options;
            return;
        }
        
        const search = searchText.toLowerCase();
        filteredOptions = options.filter(option => 
            option.toLowerCase().includes(search)
        );
    }

    function updateSuggestionsPosition() {
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            suggestionsStyle = `
                top: ${rect.bottom}px;
                left: ${rect.left}px;
                width: ${rect.width}px;
            `;
        }
    }

    function handleInput(e) {
        value = e.target.value;
        filterOptions(value);
        showSuggestions = true;
        updateSuggestionsPosition();
        
        if (typeof onChange === 'function') {
            onChange(value, e);
        }
    }

    function handleBlur() {
        // Önerilerin hemen kaybolmaması için küçük bir gecikme ekleyelim
        setTimeout(() => {
            showSuggestions = false;
        }, 200);
    }

    function handleFocus() {
        console.log("focus");
        filterOptions(value);
        showSuggestions = true;
        updateSuggestionsPosition();
    }

    function selectOption(option) {
        value = option;
        showSuggestions = false;
        
        if (typeof onChange === 'function') {
            onChange(value);
        }
    }
</script>

<style>
    .suggestions {
        position: fixed;
        margin-top: 2px;
        border-radius: 6px;
        background: white;
        border: 1px solid #ced4da;
        max-height: 200px;
        overflow-y: auto;
        z-index: 9999;
        max-width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    }
    
    .suggestion-item {
        padding: 8px 12px;
        cursor: pointer;
    }
    
    .suggestion-item:hover {
        background-color: #f8f9fa;
    }

    .autocomplete-wrapper {
        position: relative;
    }

</style>

{#if label}
    <label class="form-label" for={inputID}>
        {label}
        {#if required}
            <span class="text-red">*</span>
        {/if}
    </label>
{/if}

<div class="autocomplete-wrapper">
    <input
        bind:this={inputElement}
        type="text"
        style={style}
        class="form-control"
        class:compact={compact}
        name={fieldName}
        id={inputID}
        {required}
        bind:value
        on:input={handleInput}
        on:blur={handleBlur}
        on:focus={handleFocus}
        autocomplete="off"
    />
    
    {#if showSuggestions && options && options.length > 0}
        <div 
            class="suggestions"
            transition:slide|local={{ duration: 200 }}
            style={suggestionsStyle}
        >
            {#each filteredOptions as option}
                <div 
                    class="suggestion-item"
                    on:mousedown={() => selectOption(option)}
                >
                    {option}
                </div>
            {/each}
        </div>
    {/if}
</div>